import React, { useId } from "react";
import classnames from "classnames";
import styles from "./ComposerBar.module.scss";

export interface ComposerBarProps {
    value: string;
    onChange: (value: string) => void;
    /** Отправка; недоступна при пустом (после trim) тексте, при `sending` и при `disabledHint` */
    onSend: () => void;
    placeholder?: string;
    /** Подпись поля для скринридера (aria-label) */
    label: string;
    /** Идёт отправка: кнопка недоступна */
    sending?: boolean;
    /** Если задан (например «Нужна сеть»): поле и кнопка недоступны, подсказка видна */
    disabledHint?: string;
    /** Ref на `textarea` — для фокуса */
    inputRef?: React.Ref<HTMLTextAreaElement>;
    className?: string;
}

/**
 * Панель ввода комментария внизу экрана: многострочное поле и кнопка «Отправить».
 * Липкая (`position: sticky; bottom: 0`), отступ снизу учитывает `env(safe-area-inset-bottom)`.
 * Шрифт поля 16 px — меньше iPhone увеличивает страницу при фокусе.
 */
export const ComposerBar = ({
    value,
    onChange,
    onSend,
    placeholder,
    label,
    sending = false,
    disabledHint,
    inputRef,
    className,
}: ComposerBarProps) => {
    const hintId = useId();
    const locked = !!disabledHint;
    const canSend = !locked && !sending && value.trim() !== "";

    return (
        <div className={classnames(styles.bar, className)}>
            {disabledHint && (
                <span id={hintId} className={styles.hint}>
                    {disabledHint}
                </span>
            )}
            <div className={styles.row}>
                <textarea
                    ref={inputRef}
                    className={styles.input}
                    rows={1}
                    value={value}
                    placeholder={placeholder}
                    aria-label={label}
                    aria-describedby={disabledHint ? hintId : undefined}
                    disabled={locked}
                    onChange={(event) => onChange(event.target.value)}
                />
                <button type="button" className={styles.send} disabled={!canSend} onClick={onSend}>
                    Отправить
                </button>
            </div>
        </div>
    );
};
